import React, { Component  } from 'react';

export default class Marker extends Component {

  render() {
    const z_index = this.props.projectUnclaimed ? 1 : 99;
    const greatPlaceStyle = {
      position: 'absolute',
      transform: 'translate(-50%, -50%)',
      zIndex: z_index,
    }

    const markerImage = () => {
      let el = document.getElementById('marker-item-' + this.props.id);
      if (el && el.classList.contains('m-active')) {
        return this.props.markerCategoryHover
      } else {
        return this.props.$hover ? this.props.markerCategoryHover : this.props.markerCategory;
      }


    };

    return (
      <div className="project-marker-position" style={greatPlaceStyle}>
        <button className="project-marker">
          <img
            id={`marker-item-${this.props.id}`}
            src={markerImage()}
            data-img={this.props.markerCategory}
            data-hover={this.props.markerCategoryHover}
            alt='WIN-MAP-Marker'
            className='win-marker-item'
            />
        </button>
      </div>
    );
  }
}
